/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-horizontal[_ngcontent-%COMP%]   .form-group.col-md-10.grupo[_ngcontent-%COMP%]{\r\n    border: 3px solid #ccc!important;\r\n    border-radius: 8px;  \r\n    padding-top: 10px;\r\n    margin-top: 5px;\r\n    margin-bottom: 5px;\r\n}\r\n.fusion[_ngcontent-%COMP%]{\r\n    margin-top: 14px;\r\n}"];
export { styles as styles };
